import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './RoomCard.css';
import { LanguageContext } from '../context/LanguageContext';

const RoomCard = ({ room }) => {
  const navigate = useNavigate();
  const { t, language } = useContext(LanguageContext);

  const handleViewDetails = () => {
    navigate(`/${language.value}/room/${room.id}`);
  };

  return (
    <div className="room-card-container">
      <div className="room-card-image-wrapper">
        <img
          className="room-card-image"
          src={room.images[0].url}
          alt={room.alt}
          decoding="async"
        />
      </div>

      <div className="room-card-content">
        <div className="room-card-info">
          <h3 className="room-card-title">{t("roomTypes", "rooms")[room.key]["title"]}</h3>
          <p className="room-card-description">{t("roomTypes", "rooms")[room.key]["description"]}</p>

          <div className="room-card-features">
            {room.features.map((feature, index) => (
              <div key={index} className="room-feature">
                <span className="material-symbols-outlined notranslate room-feature-icon">
                  {feature.icon}
                </span>
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="room-card-footer">
          <div className="room-card-price">
            <span className="price-label">{t("roomTypes", "from")}</span>
            <span className="price-amount"> {room.minprice} €</span>
            <span className="price-label"> /{t("roomTypes", "night")}</span>
          </div>

          <button
            className="room-card-button"
            onClick={handleViewDetails}
          >
            <span>{t("roomTypes", "viewDetails")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;